<template>
    <div class="aside__item aside__item__selectable aside-personal-manager">
        <h2>{{$t('Отдел продаж и вопросы сотрудничества')}}</h2>

        <ul>
            <li><div class="glyphicon glyphicon-send"></div>
                <a title="Telegram" href="tg://resolve?domain=sergey_capitalist">@sergey_capitalist</a></li>
            <li><div class="glyphicon glyphicon-send"></div>
                <a title="Telegram" href="tg://resolve?domain=daria_cap">@daria_cap</a></li>
            <li><div class="glyphicon glyphicon-send"></div>
                <a title="Telegram" href="tg://resolve?domain=GoGetGun">@GoGetGun</a></li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'SalesDepartment',
};
</script>

<style scoped>

</style>

<i18n>
    {
    "en": {
        "Отдел продаж и вопросы сотрудничества": "Sales and partnership department"
    }
    }
</i18n>
